module.exports = __webpack_public_path__ + "img/attachment_file.24bc0b68.svg";